import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {useTranslation} from "react-i18next";
import {selectStore} from "../../../../../../store/selector";
import {
  educationDocumentRatingAction, fetchAddLessonAction, fetchAddLessonProfileAction,
  fetchAddLessonProfileNewAction, fetchDeleteLessonAction,
  fetchEditLessonAction,
  fetchGetMarksAction
} from "../../../../../../store/pages/admission/actions";
import {StyledEntrantThreeStep} from "./index.styles";
import {Alert, Button, Col, Divider, Form, Input, Row, Select, Spin, Table, Typography} from "antd";
import {ItemMarks} from "../../ItemMarks";


const {Option} = Select;

export const ThirdStep = ({
                            formRef,
                            onFinish,
                            onFinishFailed,
                            layout,
                            educationOrder,
                            setError,
                            formDataStepThree,
                            setFormDataStepThree,
                            initialValue,
                            setEducationOrderDataLoadingStepThree,
                            education_order_id
                          }: any) => {
  const dispatch = useDispatch();
  const {t} = useTranslation(['admission', "executorAdmissionSteps", "admissionView"]);

  const {admission: {getMarks: markTable, educationDocumentRating}} = useSelector(selectStore)

  useEffect(() => {
    if(!educationOrder.success){
      setEducationOrderDataLoadingStepThree(true)
    } else {
      setEducationOrderDataLoadingStepThree(false)
    }
  }, [educationOrder.success])

  useEffect(() => {
    //проверка до 30 предметов
    if (markTable && markTable.data && markTable.data.educationOrder.markList) {
      // setCheckVal(markTable.data.educationOrder.markList.common.length < 30)
    }

    if (markTable && markTable.data && markTable.data.educationOrder.markList.common) {
      setCheckAuthorType(markTable.data.educationOrder.markList.common.some((item:any) => item.author_type === 4))
    }

    //проверка на типы
    if (markTable && markTable.data && markTable.data.educationOrder.markList) {
      setLocked(
        educationOrder.data.base_education === "3" ? true
          : educationOrder.data.base_education !== "3" && educationOrder.data.declarant_status !== "1" ? true
            : educationOrder.data.base_education === "3" && educationOrder.data.declarant_status === "1" ? true
              : educationOrder.data.declarant_status === "1" ? true : false
      )
    }


    if (!markTable.data) {
      setError(true)
    } else if (markTable.data && markTable.data.educationOrder.markList.common.length === 0 && markTable.data.educationOrder.markList.all.length === 0) {
      setError(true)
    } else {
      setError(false)
    }
  }, [markTable])

  const [idxForSelect, setIdxForSelect] = useState({
    idxProvince: null,
    idxRegion: null
  })

  const [locked, setLocked] = useState(false)

  //проверка до 30 предметов
  const [checkVal, setCheckVal] = useState(true)
  const [dataState, setDataState] = useState({id: null,
    type: null,
    rating: null,
    subject_name: undefined,})
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    if(educationOrder.data){
      setVisible(educationOrder.data.base_education === "3" ? false
        : educationOrder.data.base_education !== "3" && educationOrder.data.declarant_status !== "1" ? false
          : educationOrder.data.base_education === "3" && educationOrder.data.declarant_status === "1" ? false
            : true)
    }
  }, [educationOrder.data])


  //add item
  const [addLessonItem, setAddLessonItem] = useState({
    education_order_id: educationOrder.data.id,
    rating: null,
    subject_name: null,
    type: "common",
    author_type: 3
  });

  //add item profile
  const [addLessonProfileItem, setAddLessonProfileItem] = useState({
    education_order_id: educationOrder.data.id,
    rating_id: null,
    rating: null,
    subject_name: null,
    speciality_id: null,
    qualification_id: null,
    type: "profile",
    author_type: 3
  })

  const [addLessonVisible, setAddLessonVisible] = useState(false)

  const [checkAuthorType, setCheckAuthorType] = useState(false)

  useEffect(() => {
    // if (initialValue.education_form) {
    //   formRef.setFieldsValue(initialValue)
    // }

    if (educationOrder.data.selectedSpecialities.length > 0 && !markTable.loading) {
      dispatch(fetchGetMarksAction(educationOrder.data.id))
    }
  }, [educationOrder.data])

  // const [formData, setFormData] = useState(initValue)

  const onValuesChange = (changedFields:any, allFields:any) => {
    setFormDataStepThree(allFields)
  }

  const onChangeSelect = (key:any, option:any) => {
    console.log('option', option)
    setIdxForSelect(prevState => ({
      ...prevState,
      [key]: option.id
    }))
  }

  const addLessonItemButton = (data:any) => {
    setDataState({
      ...data,
      education_order_id: educationOrder.data.id,
      // rating_id: data.id,
      author_type: 3
    })
  }

  const handleItemRating = (value:any) => {
    setDataState(prev => ({
      ...prev,
      rating: value
    }))
  }

  const handleItemSubjectName = (value:any) => {
    setDataState(prev => ({
      ...prev,
      subject_name: value
    }))
  }

  const addLessonMainHandler = () => {
    // @ts-ignore
    dispatch(fetchAddLessonProfileNewAction(dataState))

    addLessonItemButton({})
  }

  //изменить оценку
  const handleEditRating = (value:any, id:any, selected_speciality_id:any, item:any) => {
    // @ts-ignore
    dispatch(fetchEditLessonAction({
      education_order_id: educationOrder.data.id,
      rating_id: id,
      rating: value,
      selected_speciality_id: selected_speciality_id,
    }))
  }

  //add item handlers
  const handleLessonRating = (value:any) => {
    let newData = {...addLessonItem};
    newData = {
      ...newData,
      rating: value,
    }

    setAddLessonItem(newData)
  }

  const handleLessonSubjectName = (value:any) => {
    let newData = {...addLessonItem};
    newData = {
      ...newData,
      subject_name: value,
    }

    setAddLessonItem(newData)
  }

  const addLessonHandler = () => {
    // @ts-ignore
    dispatch(fetchAddLessonAction(addLessonItem))

    setAddLessonItem(prevState => ({
      ...prevState,
      rating: null,
      subject_name: null,
    }))
  }

  //add item profile handlers

  const addLessonFooterVisibleHandler = (data:any) => {

    setAddLessonVisible(true)

    let newData = {...addLessonProfileItem}
    newData = {
      ...newData,
      qualification_id: data.qualification_id ? data.qualification_id : null,
      speciality_id: data.speciality_id ? data.speciality_id : null,
      type: "profile",
    // @ts-ignore
      profile_id: data.id,
      qualification_name: data.qualification.caption ? data.qualification.caption : null,
      qualification_code: data.qualification.code ? data.qualification.code : null,
    }

    setAddLessonProfileItem(newData)
  }

  //добавить профильный предмет
  const handleLessonProfileRating = (value:any) => {
    let newData = {...addLessonProfileItem};
    newData = {
      ...newData,
      rating: value,
    }

    setAddLessonProfileItem(newData)
  }

  const handleLessonProfileSubjectName = (value:any) => {
    let newData = {...addLessonProfileItem};
    newData = {
      ...newData,
      subject_name: value,
    }

    setAddLessonProfileItem(newData)
  }

  const addLessonProfileHandler = () => {
    // @ts-ignore
    dispatch(fetchAddLessonProfileAction(addLessonProfileItem))

    setAddLessonProfileItem(prevState => ({
      ...prevState,
      subject_name: null,
      rating: null
    }))

    setAddLessonVisible(false)
  }

  const handleDeleteRating = (id:any) => {
    dispatch(fetchDeleteLessonAction(id))
  }

  const handleChangeDocumentRating = (count:any, rating:any) => {
    let body = {
      education_order_id: educationOrder.data.id,
      rating,
      count
    }
// @ts-ignore
    dispatch(educationDocumentRatingAction(body))
  }

  const handleRenderContentItem = () => {
    let sortedSpecialities = [] as any

    if(markTable.success && markTable.data){
      sortedSpecialities = [...markTable.data?.educationOrder?.selectedSpecialities]

      sortedSpecialities.sort((a:any, b:any) => a.priority > b.priority ? 1 : -1)
    }


    return sortedSpecialities.map((item:any, index:any) => {

        const dataSource = [
          {
            key: item.speciality.code + ' - ' + item.speciality.caption,
            qualification: item.qualification.code + ' - ' + item.qualification.caption,
            college: item.college.name,
            priority: item.priority,
            specialityId: item.speciality_id,
          }
        ]

        return (
          <Col span={24} style={{marginBottom: 16}} key={item.id}>
            <div className="result">
              <Table
                dataSource={dataSource}
                columns={columns}
                className={"admission__table admission__table--green"}
                bordered={true}
                pagination={false}
              />

              <Row gutter={12} style={{padding: 24}}>
                <Col span={12}>
                  <ItemMarks
                    headerTitle={t("admissionView:stepsTitle.stepTwo.title.required")}
                    headerColor={"green"}
                    footerVisible={false}
                    selectedSpecialityId={item.id}
                    data={item.requiredMarksByLang}
                    disabledInput={checkAuthorType}
                    span={24}
                    addLessonFooterVisibleHandler={addLessonItemButton}
                    item={item}
                    type='required'

                    canDelete={true}

                    handleEditRating={handleEditRating}
                    handleDeleteRating={handleDeleteRating}
                  />
                </Col>

                <Col span={12}>
                  <ItemMarks
                    headerTitle={t("admissionView:stepsTitle.stepTwo.title.profile")}
                    headerColor={item.statusValidate}
                    footerVisible={false}
                    selectedSpecialityId={item.id}
                    data={item.profileMarks}
                    disabledInput={checkAuthorType}
                    span={24}
                    addLessonFooterVisibleHandler={addLessonItemButton}
                    item={item}
                    type='profile'

                    canDelete={true}

                    handleEditRating={handleEditRating}
                    handleDeleteRating={handleDeleteRating}
                  />
                </Col>
              </Row>

              {
                item.id === dataState?.id &&
                  <div className="admission__content-item" style={{padding: 24}}>
                      <Typography.Text style={{
                        marginBottom: "12px",
                        display: "block"
                      }}>Добавить <strong>{dataState?.type === 'required' ? 'обязательный предмет' : 'профильный предмет'}</strong></Typography.Text>

                      <Row gutter={[16, 16]}>

                          <Col flex="58px">

                              <Select
                                  suffixIcon={null}
                                  className="marks__input"
                                  popupClassName="text-center-popup"
                                  onChange={(value:any) => handleItemRating(value)}
                                  defaultValue={dataState?.rating && dataState?.rating}
                                  value={dataState?.rating && dataState?.rating}
                              >
                                  <Select.Option value="2">2</Select.Option>
                                  <Select.Option value="3">3</Select.Option>
                                  <Select.Option value="4">4</Select.Option>
                                  <Select.Option value="5">5</Select.Option>
                                  {/*<Select.Option value="ЗЧ">ЗЧ</Select.Option>*/}
                                  {/*<Select.Option value="НЧ">НЧ</Select.Option>*/}
                                  {/*<Select.Option value="НИ">НИ</Select.Option>*/}
                              </Select>

                          </Col>

                          <Col span={18}>
                              <Input
                                  onChange={(e) => handleItemSubjectName(e.target.value)}
                                  style={{borderRadius: '8px'}}
                                  placeholder={t('admissionView:stepsCaptions.lessonTitle')}
                                  defaultValue={dataState?.subject_name && dataState?.subject_name}
                                  value={dataState?.subject_name && dataState?.subject_name}
                              />
                          </Col>

                          <Col>
                              <Button
                                  className="admission__button col-green br-green"
                                  onClick={() => addLessonMainHandler()}
                                  disabled={!(dataState?.rating && dataState?.subject_name)}
                              >
                                {t('admissionView:stepsButton.addLesson')}
                              </Button>
                          </Col>
                      </Row>
                  </div>
              }

            </div>

            {markTable.data.educationOrder.selectedSpecialities.length !== (index + 1) ? <Divider /> : null}

          </Col>
        )
      })
  }

  const columns = [
    {
      title: `${t('executorAdmissionSteps:stepOne.specialtyForm.specialty')}`,
      dataIndex: 'key',
      key: 'key',
      width: "30%"
    },
    {
      title: `${t('executorAdmissionSteps:stepOne.specialtyForm.qualification')}`,
      dataIndex: 'qualification',
      key: 'qualification',
      width: "30%"
    },
    {
      title: `${t('executorAdmissionSteps:stepOne.specialtyForm.college')}`,
      dataIndex: 'college',
      key: 'college',
      width: "30%"
    },
    {
      title: `${t('executorAdmissionSteps:stepOne.specialtyForm.priority')}`,
      dataIndex: 'priority',
      key: 'priority',
      width: "10%",
      render: (text:any, record:any, index:any) => {
        return (
          <span className="admission__border-item">
            {text}
          </span>
        )
      }
    },
  ];

  return(
    <StyledEntrantThreeStep>
      <div className="header">
        <h2>
          {t("admissionView:stepThreeTitle")}
        </h2>
      </div>

      <div className="body">

      <Form {...layout} onFinishFailed={onFinishFailed} onValuesChange={onValuesChange} form={formRef}
            onFinish={onFinish} autoComplete="off" initialValues={initialValue}
            name="third_step_form">

        {markTable && markTable.data && markTable.data.educationOrder.markList.required ?
          markTable && markTable.data && markTable.data.educationOrder.markList.required.length > 0 ?
            <>
              <h3 style={{marginBottom: '16px'}}>{t("stepThree.marksTitle")}</h3>
              {/*{locked && checkVal &&*/}
              {/*  <div style={{marginBottom: 20}}>*/}
              {/*    <AddLesson*/}
              {/*      title={t('admissionView:stepsTitle.stepTwo.caption.addSimpleLesson')}*/}
              {/*      handleLessonRating={handleLessonRating}*/}
              {/*      handleLessonSubjectName={handleLessonSubjectName}*/}
              {/*      addLessonHandler={addLessonHandler}*/}
              {/*      addLessonItem={addLessonItem}*/}
              {/*    />*/}
              {/*  </div>*/}
              {/*}*/}

              {/*<div className="admission__content-item">*/}
              {/*  <ItemMarks*/}
              {/*    headerTitle={t("stepThree.marksTitle")}*/}
              {/*    footerVisible={false}*/}
              {/*    data={markTable && markTable.data && markTable.data.educationOrder.markList.common}*/}
              {/*    disabledInput={checkAuthorType}*/}
              {/*    span={8}*/}

              {/*    canDelete={true}*/}

              {/*    handleEditRating={handleEditRating}*/}
              {/*    handleDeleteRating={handleDeleteRating}*/}
              {/*  />*/}
              {/*</div>*/}

              <div className="admission__content-item">
                {
                  [5, 4, 3, 2].map((item, index) => (
                    <Row className="marks__item" style={{marginBottom: 16}} key={item}>
                      <Col flex="46px">
                        <Input className='marks__input' onChange={(e) => handleChangeDocumentRating(e.target.value, item)} maxLength={2} onKeyPress={(event) => {
                          if (!/[0-9]/.test(event.key)) {
                            event.preventDefault();
                          }
                        }} defaultValue={markTable && markTable.data && markTable.data.educationOrder && markTable.data.educationOrder.educationDocument.ratings[index].count}/>
                      </Col>
                      <Col style={{marginLeft: 16}}>
                        <Typography.Text style={{marginLeft: 0}}>{t('admissionView:countInEducationDocument', {item: item})}</Typography.Text>
                      </Col>
                    </Row>
                  ))
                }


                <Row gutter={16}>
                  <Col>
                    <Alert
                      message={<span>{t('admissionView:totalAvgSubject')} <strong style={{marginLeft: 16}}>{markTable && markTable.data && markTable.data.educationOrder && markTable.data.educationOrder.educationDocument.count}</strong></span>}
                      type="success"
                      style={{position: 'relative', bottom: 0}}
                    />
                  </Col>

                  <Col>
                    <Alert
                      message={<span>{t('admissionView:totalAvgRating')} <strong style={{marginLeft: 16}}>{markTable && markTable.data && markTable.data.educationOrder && markTable.data.educationOrder.educationDocument.avg_rating}</strong></span>}
                      type="warning"
                    />
                  </Col>
                </Row>
              </div>

              <Divider />

              <div className="admission__content-item">

                <div className="admission__content-item">

                  <Row>
                    {handleRenderContentItem()}
                  </Row>
                </div>
              </div>

              {/*<Row style={{marginTop: 10, marginBottom: 20}}>*/}
              {/*  <Col span={24}>*/}
              {/*    <Row justify="space-between" gutter={[16, 16]}>*/}
              {/*      {markTable && markTable.data && markTable.data.educationOrder.markList.profile.map(item => (*/}
              {/*        <Col span={12} key={item.id}>*/}
              {/*          <ItemMarks*/}
              {/*            headerTitle={item.qualification.code + ' - ' + item.qualification.caption}*/}
              {/*            footerVisible={locked}*/}
              {/*            data={item.profileMarks}*/}
              {/*            disabledInput={checkAuthorType}*/}
              {/*            span={24}*/}
              {/*            addLessonFooterVisibleHandler={addLessonFooterVisibleHandler}*/}
              {/*            item={item}*/}

              {/*            canDelete={locked}*/}

              {/*            handleEditRating={handleEditRating}*/}
              {/*            handleDeleteRating={handleDeleteRating}*/}
              {/*          />*/}
              {/*        </Col>*/}
              {/*      ))}*/}


              {/*    </Row>*/}
              {/*  </Col>*/}
              {/*</Row>*/}
              {/*{addLessonVisible &&*/}
              {/*<AddLessonProfile*/}
              {/*  title={`${t('admissionView:stepsTitle.stepTwo.caption.addProfileLesson')} | ${addLessonProfileItem.qualification_code} - ${addLessonProfileItem.qualification_name}`}*/}
              {/*  handleLessonProfileRating={handleLessonProfileRating}*/}
              {/*  handleLessonProfileSubjectName={handleLessonProfileSubjectName}*/}
              {/*  addLessonProfileHandler={addLessonProfileHandler}*/}
              {/*  addLessonProfileItem={addLessonProfileItem}*/}
              {/*/>*/}
              {/*}*/}
            </> : <Spin style={{
              textAlign: "center",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100%"
            }}/>


          // (markTable && markTable.data && markTable.data.educationOrder.markList.commonWithRequired.length) === 0 && (markTable && markTable.data && markTable.data.educationOrder.markList.all.length > 0) ? (
          //   <>
          //     <ItemMarks
          //       headerTitle={t("stepThree.marksTitle")}
          //       footerVisible={false}
          //       data={markTable && markTable.data && markTable.data.educationOrder.markList.all}
          //       disabledInput={checkAuthorType}
          //       span={8}
          //
          //       canDelete={true}
          //
          //       handleEditRating={handleEditRating}
          //       handleDeleteRating={handleDeleteRating}
          //     />
          //
          //     <Row style={{marginTop: 10, marginBottom: 20}}>
          //       <Col span={24}>
          //         <Row justify="space-between" gutter={[16, 16]}>
          //           {markTable && markTable.data && markTable.data.educationOrder.markList.profile.map(item => (
          //             <Col span={12} key={item.id}>
          //               <ItemMarks
          //                 headerTitle={item.qualification.code + ' - ' + item.qualification.caption}
          //                 footerVisible={locked}
          //                 data={item.profileMarks}
          //                 disabledInput={checkAuthorType}
          //                 span={24}
          //                 addLessonFooterVisibleHandler={addLessonFooterVisibleHandler}
          //                 item={item}
          //
          //                 canDelete={locked}
          //
          //                 handleEditRating={handleEditRating}
          //                 handleDeleteRating={handleDeleteRating}
          //               />
          //             </Col>
          //           ))}
          //
          //
          //         </Row>
          //       </Col>
          //     </Row>
          //   </>
          // ) : null
          :
          <Spin style={{
            textAlign: "center",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100%"
          }}/>
        }

      </Form>
      </div>

    </StyledEntrantThreeStep>
  )
}